module.exports = __webpack_public_path__ + "static/media/5DPO16.e4a91eb1.jpg";